export default __webpack_public_path__ + "static/media/Ch2c.d634624d.gif";